import { Form } from '@src/Api/Umbraco/interface/UmbracoTypes';
import { SocialNetworkSource } from '@src/Store/Slices/AppSlice/auth.slice';

export function filterFormFields(form: Form | undefined, socialNetworkSource: SocialNetworkSource): Form | null {
  if (!form) return null;

  const shouldKeepField = (field: any) => {
    if (
      socialNetworkSource !== 'email' &&
      (field.alias === 'email' || field.alias === 'password')
    ) {
      return false;
    }
    return true;
  };

  const pages = form.pages.map(page => ({
    ...page,
    fieldsets: page.fieldsets.map(fieldset => ({
      ...fieldset,
      columns: fieldset.columns.map(column => ({
        ...column,
        fields: column.fields.filter(shouldKeepField),
      })),
    })),
  }));

  return { ...form, pages };
}